import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Login from "components/Login";

class LoginPage extends Component {
  render() {
    return (
      <div className="container-fluid no-padding">
        <Login />
      </div>
    );
  }
}

export default withRouter(LoginPage);



// WEBPACK FOOTER //
// ./containers/Login.js